import WarningAlt16 from '@carbon/icons-react/es/warning--alt/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import {
  ProjectBudgetThresholdReached,
  ProjectHoursThresholdReached,
} from 'api/notifications/meta/financial-events';

const getColorForAlert = (thresholdPercentage: number) => {
  if (thresholdPercentage >= 100) {
    return 'red';
  }

  if (thresholdPercentage >= 80) {
    return 'yellow';
  }

  return 'green';
};

const WarningIcon = styled(WarningAlt16)<{
  color: 'red' | 'yellow' | 'green';
}>`
  ${({ color }) => css`
    color: var(--${color}-50);
  `};
`;

export const ProjectBudgetThresholdReachedView: FC<{
  meta: ProjectBudgetThresholdReached;
}> = ({ meta: { thresholdPercentage } }) => (
  <FormattedMessage
    id="notifications.messages.project_hours.exceeded"
    values={{
      icon: <WarningIcon color={getColorForAlert(thresholdPercentage)} />,
      percent: thresholdPercentage,
      strong: (chunks) => <strong>{chunks}</strong>,
    }}
  />
);

export const ProjectHoursThresholdReachedView: FC<{
  meta: ProjectHoursThresholdReached;
}> = ({ meta: { thresholdPercentage } }) => (
  <FormattedMessage
    id="notifications.messages.project_budget.exceeded"
    values={{
      icon: <WarningIcon color={getColorForAlert(thresholdPercentage)} />,
      percent: thresholdPercentage,
      strong: (chunks) => <strong>{chunks}</strong>,
    }}
  />
);
